





























































import { Vue, Component } from "vue-property-decorator";
import moment from "moment";
import MyRoutineUsersController, {
  MyRoutineUserForDownloading
} from "@/controller/my-routine-users";

const controller = new MyRoutineUsersController();

@Component
export default class MyRoutineUsersDownload extends Vue {
  isSolved = false;
  isSolvedText = "Đã tư vấn";
  notSolvedText = "Chưa tư vấn";
  today = moment(new Date()).format("YYYY-MM-DD");
  dateRange: string[] = [this.today, this.today];

  get sortedDateRange(): string[] {
    return this.dateRange.sort((dateA: string, dateB: string) => {
      return new Date(dateA).getTime() - new Date(dateB).getTime();
    });
  }

  get startDate(): Date {
    return new Date(this.sortedDateRange[0]);
  }

  get endDate(): Date {
    return new Date(`${this.sortedDateRange[1]} 23:59:59`);
  }

  get displayStartDate(): string {
    return `${this.sortedDateRange[0]} 00:00:00`;
  }

  get displayEndDate(): string {
    if (!this.isValidDateRange) return "";
    return `${this.sortedDateRange[1]} 23:59:59`;
  }

  get isValidDateRange(): boolean {
    return !!this.sortedDateRange[1];
  }

  get displayIsSolved(): string {
    return this.isSolved ? this.isSolvedText : this.notSolvedText;
  }

  async download() {
    if (!this.isValidDateRange) {
      this.toastError("Vui lòng chọn ngày kết thúc");
      return;
    }

    const users = await controller.getDownloadData(
      this.isSolved,
      this.startDate,
      this.endDate
    );
    const csv = this.convertDataToCsv(users);
    if (!csv) {
      this.toastError("Không có dữ liệu");
      return;
    }

    this.downloadFile(csv);
  }

  private toastError(message: string) {
    this.$toasted.show(message, {
      theme: "toasted-primary",
      position: "top-right",
      icon: "mdi-home",
      duration: 3000,
      action: {
        text: "Tắt",
        onClick: (e, toastObject) => {
          toastObject.goAway(0);
        }
      }
    });
  }

  private convertDataToCsv(data: MyRoutineUserForDownloading[]): string {
    const csv = "data:text/csv;charset=utf-8,";
    let fileHeader = "";
    let fileContent = "";
    const delimiter = ",";
    const newLine = "\r\n";

    data.forEach((user: MyRoutineUserForDownloading) => {
      if (fileHeader === "") {
        fileHeader = Object.keys(user).join(delimiter) + newLine;
      }
      const row = Object.values(user).join(delimiter) + newLine;
      fileContent += row;
    });

    if (fileHeader === "") {
      return "";
    }

    return csv + fileHeader + fileContent;
  }

  private downloadFile(csv: string) {
    window.open(encodeURI(csv));
  }
}
